import './LegalEditorPage.scss';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import TopNav from '../../components/TopNav/TopNav';
import SideBar from '../../components/SideBar/SideBar';
import LegalEditor from '../../components/LegalEditor/LegalEditor';

const surfaceNames = {
    app: 'Mobile App',
    business: 'Business Panel',
    zonavip: 'ZONA VIP',
    brandambassador: 'Brand Ambassador',
    advertiser: 'Ads Portal',
    promoter: 'Promoter Portal',
};

const documentKinds = {
    terms: 'Terms',
    policy: 'Privacy',
    contract: 'Contract',
    'content-policy': 'Content Policy',
};

const privacyDocuments = new Set(['policy']);

export default function LegalEditorPage() {
    const { type, document } = useParams();
    const navigate = useNavigate();

    const surfaceName = surfaceNames[type] || type;
    const kind = documentKinds[document] || 'Document';
    const backTo = privacyDocuments.has(document)
        ? '/settings/privacy-policy'
        : '/settings/terms-and-conditions';
    const backLabel = privacyDocuments.has(document)
        ? 'Privacy Policy'
        : 'Terms and Conditions';

    return (
        <main>
            <TopNav />
            <div className='main-container'>
                <SideBar />
                <article className='page-content'>
                    <section className='legal-page'>
                        <div className='legal-page__topbar'>
                            <button
                                type='button'
                                className='legal-page__back'
                                onClick={() => navigate(backTo)}
                            >
                                <ArrowLeft size={16} />
                                <span>Back to {backLabel}</span>
                            </button>
                        </div>

                        <header className='legal-page__header'>
                            <div className='legal-page__crumb'>
                                {backLabel} · {surfaceName}
                            </div>
                            <h1>
                                {surfaceName} <span>— {kind}</span>
                            </h1>
                        </header>

                        <LegalEditor
                            key={`${type}-${document}`}
                            type={type}
                            document={document}
                            kind={kind}
                        />
                    </section>
                </article>
            </div>
        </main>
    );
}
